import React, { useState, useEffect,useRef } from 'react';
import Layout from './Layout';
import AxiosInstance from '../AxiosInstance';
import { ArrowLeftCircle } from "react-bootstrap-icons";
import { Button, Row, Col } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from '../Pagination';
import ToastNotification from '../ToastNotification';

const TableRepresentation = () => {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [performanceData, setPerformanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const toastRef = useRef(null);

  useEffect(() => {
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();
    setMonth(currentMonth);
    setYear(currentYear);
  }, []);
  
  const fetchPerformanceData = async (monthVal, yearVal, page = 1, searchTerm = '') => {
    if (!monthVal || !yearVal) return;
  
    setLoading(true);
    try {
      const res = await AxiosInstance.get(`/admin/monthly-performance-table`, {
        params: { 
          month: monthVal, 
          year: yearVal, 
          page, 
          search: searchTerm // Add search term here
        },
      });
  
      if (Array.isArray(res.data.data)) {
        setPerformanceData(res.data.data);  // Adjust according to your API response structure
        setTotalPages(res.data.totalPages);  // Update totalPages based on your response
      } else {
        toastRef.current?.showToast('Invalid data format received:', "danger");
      }
    } catch (err) {
      toastRef.current?.showToast('Error fetching performance:',"danger");
    } finally {
      setLoading(false);
    }
  };
  
   // Fetch data when month or year changes
   useEffect(() => {
    if (month && year) {
      fetchPerformanceData(month, year, currentPage, searchTerm); // Pass searchTerm here
    }
  }, [month, year, currentPage, searchTerm]); // Add searchTerm to dependencies
  
  
  const capitalizeName = (name) => {
    return name
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <Layout heading="Monthly Performance">
      <Row className="mb-3">
        <Col xs={12}>
          <Button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
          </Button>
        </Col>
      </Row>

      <div className="container mt-4">
        {/* Month-Year Picker */}
        <Row className="mb-3 g-2">
          <Col xs={12} md="auto">
            <DatePicker
              selected={month && year ? new Date(year, month - 1) : null}
              onChange={(date) => {
                setMonth(date.getMonth() + 1);
                setYear(date.getFullYear());
              }}
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              className="form-control"
              placeholderText="Select month and year"
            />
          </Col>
        </Row>

        {/* Search Bar */}
        <Row className="mb-3 justify-content-md-start justify-content-center">
          <Col xs={12} md={6} lg={4} xl={3}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by employee name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>
        </Row>
        {/* Table or Loading */}
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
          <div className="row mt-3">
            <div className="col">
               <div className="d-block d-md-none" style={{ maxHeight: '320px', overflowY: 'auto' }}>
                  <div className="table-responsive">
                  <table className="table table-hover text-center align-middle table-striped">
                    <thead className="table-primary">
                      <tr>
                        <th scope="col">#</th>
                        <th className="text-start">Employee Code</th>
                        <th className="text-start">Employee Name</th>
                        <th className="text-start">Total Hours</th>
                        <th className="text-start">Actual Work Hours</th>
                        <th className="text-start">Leave Hours</th>
                        <th className="text-start">Public Holidays</th>
                      </tr>
                    </thead>
                    <tbody>
                      {performanceData.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-muted">
                            No data found
                          </td>
                        </tr>
                      ) : (
                        performanceData
                          .filter((emp) =>
                            emp.employee_name.toLowerCase().includes(searchTerm.toLowerCase())
                          )
                          .map((emp, index) => (
                            <tr key={index}>
                              <td>{(currentPage - 1) * 10 + index + 1}</td>
                              <td className="text-start">{emp.employee_code}</td>
                              <td className="text-start">{capitalizeName(emp.employee_name)}</td>
                              <td className="text-start">{emp.total_possible_hours}</td>
                              <td className="text-start">{emp.actual_work_hours}</td>
                              <td className="text-start">{emp.leave_hours}</td>
                              <td className="text-start">{emp.public_holiday_hours}</td>
                            </tr>
                          ))
                      )}
                    </tbody>
                  </table>
                </div>
               </div>
               <div className="d-none d-md-block">
                    <div className="table-responsive">
                      <table className="table table-hover text-center align-middle table-striped">
                        <thead className="table-primary">
                          <tr>
                            <th scope="col">#</th>
                            <th className="text-start">Employee Code</th>
                            <th className="text-start">Employee Name</th>
                            <th className="text-start">Total Hours</th>
                            <th className="text-start">Actual Work Hours</th>
                            <th className="text-start">Leave Hours</th>
                            <th className="text-start">Public Holidays</th>
                          </tr>
                        </thead>
                        <tbody>
                          {performanceData.length === 0 ? (
                            <tr>
                              <td colSpan="7" className="text-muted">
                                No data found
                              </td>
                            </tr>
                          ) : (
                            performanceData
                              .filter((emp) =>
                                emp.employee_name.toLowerCase().includes(searchTerm.toLowerCase())
                              )
                              .map((emp, index) => (
                                <tr key={index}>
                                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                                  <td className="text-start">{emp.employee_code}</td>
                                  <td className="text-start">{capitalizeName(emp.employee_name)}</td>
                                  <td className="text-start">{emp.total_possible_hours}</td>
                                  <td className="text-start">{emp.actual_work_hours}</td>
                                  <td className="text-start">{emp.leave_hours}</td>
                                  <td className="text-start">{emp.public_holiday_hours}</td>
                                </tr>
                              ))
                          )}
                        </tbody>
                      </table>
                    </div>
               </div>
            </div>
          </div>
            {/* Pagination */}
            <Row className="justify-content-center mt-4">
              <Col xs="auto">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </Col>
            </Row>
          </>
        )}
        <ToastNotification ref={toastRef} />
      </div>
    </Layout>

  );
};

export default TableRepresentation;
